
import { throwError as observableThrowError, Observable } from 'rxjs';

import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';

import { ServiceBase } from '@app/services/base.service';
import { Conta } from '@app/models/conta.model';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class ContaService extends ServiceBase {
  constructor(private http: HttpClient) {
    super();
  }
  gravar(conta: Conta): Observable<any> {
    return this.http
      .post<any>(this.URL_API + 'configuracoes/conta', conta).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  deletar(id: number): Observable<any> {
    return this.http
      .delete<any>(this.URL_API + `configuracoes/conta/${id}`);
  }

  obterPorId(id: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `configuracoes/conta/${id}`);
  }

  obterLista(descricao: string, pagina: number): Observable<any> {
    descricao = encodeURIComponent(descricao);
    return this.http
      .get<any>(this.URL_API + `configuracoes/conta/lista/?descricao=${descricao}&pagina=${pagina}`, { headers: { meta: ['search'] }});
  }

}
